import { axiosGet } from './api';

/**
 * Authenticated download for private Company Profile source files.
 * Respects backend sharing rules (owner / shared Lead Agents / admin).
 */
export const downloadProfileSourceFile = async (sourceId, fileName = 'file') => {
  const res = await axiosGet(`/company-profile/sources/${sourceId}/file`, {
    responseType: 'blob',
  });

  const blobUrl = window.URL.createObjectURL(res.data);
  const anchor = document.createElement('a');
  anchor.href = blobUrl;
  anchor.target = '_blank';
  anchor.rel = 'noopener noreferrer';
  // Prefer opening inline when possible; download attribute as fallback name.
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  window.setTimeout(() => window.URL.revokeObjectURL(blobUrl), 1000);
};
